module.exports = (() => {
  const CONFIG_STUDENT_STAGING = {
    folioHost: 'https://tcfolio-dev.web.app/',
    apiHost: 'https://tcas65-staging-dot-tcas65.as.r.appspot.com',
    genPdfApiHost: 'https://tcas-staging-pdf-dot-tcas65.as.r.appspot.com',
    // apiHost: 'http://localhost:8020',
    facebookAppId: '552078457771249',
    thaid: {
      host: 'https://imauth.bora.dopa.go.th',
      clientId: 'U09kc01LUHRHMVlzSXZHdlFVVjdEYTBBMTdMNUJFU1M',
      // apiHost ชี้ instance prod เสมอ: redirect_uri ที่ลงทะเบียนกับ DOPA มีตัวเดียว (prod)
      // → callback + handoff code เกิดบน instance นั้น ต้องแลก code ที่ตัวเดียวกัน
      apiHost: 'https://tcas-student-api-thaid-dot-tcas65.as.r.appspot.com'
    }
    // thaid: {
    //   host: 'https://imauthsbx.bora.dopa.go.th',
    //   clientId: 'RlJCR2poM2RFdEtVeUN5cjRnYklxbWY4Q09HZ0NORXU'
    // }
  };
  const CONFIG_STUDENT_PROD = {
    folioHost: 'https://folio.mytcas.com/',
    apiHost: 'https://tcas65.as.r.appspot.com',
    genPdfApiHost: 'https://tcas-pdf-dot-tcas65.as.r.appspot.com',
    facebookAppId: '552078457771249',
    thaid: {
      host: 'https://imauth.bora.dopa.go.th',
      clientId: 'U09kc01LUHRHMVlzSXZHdlFVVjdEYTBBMTdMNUJFU1M',
      apiHost: 'https://tcas-student-api-thaid-dot-tcas65.as.r.appspot.com'
    }
  };

  // e2e: full-local stack (Playwright) — backend NODE_ENV=e2e + Mongo db tcas-e2e
  if (process.env.REACT_APP_E2E === 'true') {
    return {
      apiHost: 'http://localhost:8020',
      genPdfApiHost: 'http://localhost:8021',
      folioHost: 'http://localhost:3000/',
      facebookAppId: '552078457771249',
      thaid: {
        host: 'http://localhost:8030', // mock imauth (e2e/fixtures)
        clientId: 'e2e-mock-client',
        apiHost: 'http://localhost:8030',
      },
    };
  }

  if (process.env.NODE_ENV === 'production') {
    const isStaging = process.env.REACT_APP_STAGING === 'true';
    return isStaging ? CONFIG_STUDENT_STAGING : CONFIG_STUDENT_PROD;
  }

  // Default config
  return {
    apiHost: 'https://tcas65-staging-dot-tcas65.as.r.appspot.com',
    genPdfApiHost: 'https://tcas-staging-pdf-dot-tcas65.as.r.appspot.com',
    // apiHost: 'http://localhost:8020',
    // genPdfApiHost: 'http://localhost:8021',
    folioHost: 'https://tcfolio-dev.web.app/',
    // apiHost: 'https://tcas65.as.r.appspot.com',
    // genPdfApiHost: 'https://tcas-pdf-dot-tcas65.as.r.appspot.com',
    facebookAppId: '552078457771249',
    thaid: {
      host: 'https://imauth.bora.dopa.go.th',
      clientId: 'U09kc01LUHRHMVlzSXZHdlFVVjdEYTBBMTdMNUJFU1M',
      // apiHost ชี้ instance prod เสมอ — เหตุผลเดียวกับ CONFIG_STUDENT_STAGING ข้างบน
      apiHost: 'https://tcas-student-api-thaid-dot-tcas65.as.r.appspot.com'
    }
    // thaid: {
    //   host: 'https://imauthsbx.bora.dopa.go.th',
    //   clientId: 'RlJCR2poM2RFdEtVeUN5cjRnYklxbWY4Q09HZ0NORXU'
    // }
  };
})();
